import { axios } from '../http-common';

class Companies {

    remittanceList(data){
        return axios.get("v1/member/remittance/history",{params:data});
    }

    withdrawalList(data){
        return axios.get("v1/member/withdrawal/history",{params:data});
    }

    partnerList(data){
        return axios.get("v1/member/accounts/getcompany-list",{params:data}); 
    }

    accountsTransfer(data){
        return axios.post("v1/member/accounts/transfer",data);
    }

    consolidationRequest(data){
        return axios.post("v1/member/accounts/remittance-transit",data);
    }

    beneficiaryList(data){
        return axios.get("v1/member/withdrawal-benificiary/list",{params:data});
    }

    submitWithdrawal(data){
        return axios.post("v1/member/withdrawal/request",data);
    }

    submitRemittance(data){
        return axios.post("v1/member/remittance/request",data);
    }
    
    addBenificiary(data){
        return axios.post("v1/member/withdrawal-benificiary/add",data);
    }

    updatePartner(data){
        return axios.post("v1/member/partner/update",data);
    }

    updateBeneficiary(data){
        return axios.post("v1/member/withdrawal-benificiary/update",data);
    }

    addPartner(data){
        return axios.post("v1/member/accounts/addcompannyrelationship",data);
    }
}

export default new Companies();